// import React, { useEffect, useRef, useState } from "react";
// // import { Typography } from "@progress/kendo-react-common";
// import { useAppDispatch, useAppSelector } from "../../app/hooks";
// import {
//   getDashBoardCount,
//   getDashBoardFollowups,
//   // tokenCheck,
// } from "./services/dashboard.services";
// // import { LoadingPanel } from "../../components/layout/Loading";
// import { motion } from "framer-motion";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import { Pie } from "react-chartjs-2";
// import "./Dashboard.scss";
// import { BsBookmarkPlusFill } from "react-icons/bs";
// import { TbReceiptRupee } from "react-icons/tb";
// import { RiBookMarkedFill, RiInfoCardLine } from "react-icons/ri";
// import { IoMdPersonAdd } from "react-icons/io";
// // import { GiMoneyStack } from "react-icons/gi";
// import IconComponent from "../../components/common/IconComponent";
// import {
//   Field,
//   Form,
//   FormElement,
//   FormRenderProps,
// } from "@progress/kendo-react-form";
// import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
// import moment from "moment";
// import { Typography } from "@progress/kendo-react-common";
// import FormDatePicker from "../../components/formFields/FormDateField";
// import FormSelectionField from "../../components/formFields/FormSelectionField";
// import { DateRangeFilter, EDIT_ACCESS } from "../../_contstants/common";
// import { checkAcessRights, getFilterFromToDate } from "../../_helper/helper";
// import {
//   setActiveTabIndex,
//   setDateFilter,
//   setFolloupID,
// } from "./dashboardSlice";
// import { Link, useNavigate } from "react-router-dom";
// import { updateFollowUpStatus } from "../inquiry/services/inquiry.services";
// import { LoadingPanel } from "../../components/layout/Loading";
// import { opened } from "../../components/drawer/drawerSlice";
// import { IDrawerState } from "../../components/drawer/drawerModel";
// import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
// import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
// import { RxCross1 } from "react-icons/rx";
// import ButtonWithLoading from "../../components/common/ButtonWithLoading";
// import FormTextArea from "../../components/formFields/FormTextArea";
// import IconButton from "../../components/common/IconButton";

// ChartJS.register(ArcElement, Tooltip, Legend);

// const DashBoardCardData = [
//   {
//     title: "Bookings",
//     icon: <IconComponent icon={BsBookmarkPlusFill} />,
//     link: "dashboard/booking",
//   },
//   {
//     title: "Quotations",
//     icon: <IconComponent icon={TbReceiptRupee} />,
//     link: "dashboard/quotation",
//   },
//   {
//     title: "Inquiries",
//     icon: <IconComponent icon={RiInfoCardLine} />,
//     link: "dashboard/inquiry",
//   },
//   {
//     title: "Leads",
//     icon: <IconComponent icon={IoMdPersonAdd} />,
//     link: "dashboard/lead",
//   },
//   {
//     title: "FIT Bookings",
//     icon: <IconComponent icon={RiBookMarkedFill} />,
//     link: "dashboard/fitbooking",
//   },
// ];

// const getDashboardCardData = (title: string, type: "icon" | "link") => {
//   const item = DashBoardCardData.find((data) => data.title === title);
//   if (!item) return null;

//   return type === "icon" ? item.icon : item.link || "#";
// };

// // const DashboardIcons: any = {
// //   Leads: <IconComponent icon={IoMdPersonAdd} />,
// //   Inquiries: <IconComponent icon={RiInfoCardLine} />,
// //   Quotations: <IconComponent icon={TbReceiptRupee} />,
// //   Bookings: <IconComponent icon={BsBookmarkPlusFill} />,
// // };

// interface DateFilterChangeWatcherProps {
//   formRenderProps: FormRenderProps;
// }
// const DateFilterChangeWatcher: React.FC<DateFilterChangeWatcherProps> = ({
//   formRenderProps,
// }) => {
//   const dispatch = useAppDispatch();
//   const SelectedDate = formRenderProps.valueGetter("SelectedDate");
//   const FromDate = formRenderProps.valueGetter("FromDate");
//   const ToDate = formRenderProps.valueGetter("ToDate");
//   const next15Days = new Date(new Date().setDate(new Date().getDate() + 15));

//   useEffect(() => {
//     if (SelectedDate !== 6) {
//       formRenderProps.onChange("FromDate", { value: null });
//       formRenderProps.onChange("ToDate", { value: null });
//       const filter = getFilterFromToDate(SelectedDate);
//       if (filter.FromDate === "" && filter.ToDate === "") {
//         const DefaultDate = {
//           FromDate: moment(new Date()).format("YYYY-MM-DD"),
//           ToDate: moment(next15Days).format("YYYY-MM-DD"),
//         };
//         dispatch(getDashBoardCount(DefaultDate));
//         dispatch(getDashBoardFollowups(DefaultDate));
//         dispatch(setDateFilter({ SelectedDate, ...DefaultDate }));
//       } else {
//         dispatch(getDashBoardCount(filter));
//         dispatch(getDashBoardFollowups(filter));
//         dispatch(setDateFilter({ SelectedDate, ...filter }));
//       }
//     }
//   }, [SelectedDate]);

//   useEffect(() => {
//     const filter = {
//       FromDate: FromDate
//         ? moment(FromDate).format("YYYY-MM-DD")
//         : moment(new Date()).format("YYYY-MM-DD"),
//       ToDate: ToDate
//         ? moment(ToDate).format("YYYY-MM-DD")
//         : moment(next15Days).format("YYYY-MM-DD"),
//     };
//     if (FromDate && ToDate) {
//       dispatch(getDashBoardCount(filter));
//       dispatch(getDashBoardFollowups(filter));
//       dispatch(setDateFilter({ SelectedDate, ...filter }));
//     }
//   }, [FromDate, ToDate]);
//   return null;
// };

// const Dashboard: React.FC = () => {
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   const gridRef = useRef<any>(null);
//   const gridFOrmLoadingRef = useRef<any>(null);
//   const DashBoardCountList = useAppSelector(
//     (state) => state.dashboard.DashBoardCountList
//   );
//   const DashboardInquiryFollowups = useAppSelector(
//     (state) => state.dashboard.DashboardInquiryFollowups
//   );
//   const DashboardLeadFollowups = useAppSelector(
//     (state) => state.dashboard.DashboardLeadFollowups
//   );
//   const isLeadEditAccess = checkAcessRights("/lead", EDIT_ACCESS);
//   const isInquiryEditAccess = checkAcessRights("/inquiry", EDIT_ACCESS);

//   const dateFilter = useAppSelector((state) => state?.dashboard?.dateFilter);
//   const formatedDateFilter = {
//     ...dateFilter,
//     FromDate: dateFilter.FromDate
//       ? moment(dateFilter?.FromDate, "YYYY-MM-DD").toDate()
//       : "",
//     ToDate: dateFilter.ToDate
//       ? moment(dateFilter?.ToDate, "YYYY-MM-DD").toDate()
//       : "",
//   };

//   const loading = useAppSelector((state) => state.dashboard.loading);
//   const followUpLoading = useAppSelector(
//     (state) => state.dashboard.followUpLoading
//   );
//   const loginDetails = useAppSelector((state) => state.login.loginDetails);

//   // useEffect(() => {
//   //   dispatch(tokenCheck());
//   // }, []);

//   // const stats = [
//   //   {
//   //     title: "Bookings",
//   //     count: 120,
//   //     icon: <IconComponent icon={BsBookmarkPlusFill} />,
//   //   },
//   //   {
//   //     title: "Quotations",
//   //     count: 85,
//   //     icon: <IconComponent icon={TbReceiptRupee} />,
//   //   },
//   //   {
//   //     title: "Inquiries",
//   //     count: 45,
//   //     icon: <IconComponent icon={RiInfoCardLine} />,
//   //   },
//   //   {
//   //     title: "Leads",
//   //     count: 200,
//   //     icon: <IconComponent icon={IoMdPersonAdd} />,
//   //   },
//   // ];

//   // const leadFollowUps = [
//   //   {
//   //     id: 1,
//   //     name: "Sarah Connor",
//   //     date: "2025-02-27",
//   //     time: "10:30 AM",
//   //     description: "Interested in a Paris trip package",
//   //   },
//   //   {
//   //     id: 2,
//   //     name: "Michael Scott",
//   //     date: "2025-02-28",
//   //     time: "09:15 AM",
//   //     description: "Needs quote for New York business trip",
//   //   },
//   //   {
//   //     id: 4,
//   //     name: "Jim Halpert",
//   //     date: "2025-03-02",
//   //     time: "02:30 PM",
//   //     description: "Wants to book a Tokyo tour",
//   //   },
//   //   {
//   //     id: 6,
//   //     name: "Angela Martin",
//   //     date: "2025-03-04",
//   //     time: "01:00 PM",
//   //     description: "Interested in a London luxury trip",
//   //   },
//   // ];

//   // const inquiryFollowUps = [
//   //   {
//   //     id: 3,
//   //     name: "Pam Beesly",
//   //     date: "2025-03-01",
//   //     time: "11:00 AM",
//   //     description: "Inquiry about Bali honeymoon package",
//   //   },
//   //   {
//   //     id: 5,
//   //     name: "Dwight Schrute",
//   //     date: "2025-03-03",
//   //     time: "03:45 PM",
//   //     description: "Request for a rural farm stay package",
//   //   },
//   // ];

//   const [activeTab, setActiveTab] = useState<"Lead" | "Inquiry">("Lead");

//   const displayedFollowUps =
//     activeTab === "Lead" ? DashboardLeadFollowups : DashboardInquiryFollowups;

//   const listVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         staggerChildren: 0.1,
//         duration: 0.5,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0 },
//   };

//   const pieData = {
//     labels: DashBoardCountList?.map((e) => e?.Title),
//     datasets: [
//       {
//         data: DashBoardCountList.map((card) => card.TotalCount),
//         backgroundColor: ["#174583", "#4EBECF", "#17458380", "#4EBECF80"],
//         borderColor: ["#174583", "#4EBECF", "#174583", "#4EBECF"],
//         borderWidth: 2,
//         hoverOffset: 5,
//       },
//     ],
//   };

//   const pieOptions = {
//     responsive: true,
//     maintainAspectRatio: true,
//     aspectRatio: 1,
//     plugins: {
//       legend: {
//         position: "bottom" as const,
//         labels: {
//           color: "#333",
//           font: { size: 14, weight: "bold" as const },
//           padding: 20,
//           boxWidth: 20,
//           boxHeight: 20,
//         },
//       },
//       tooltip: {
//         backgroundColor: "#174583",
//         titleColor: "white",
//         bodyColor: "white",
//         borderColor: "#4EBECF",
//         borderWidth: 1,
//         caretSize: 0,
//         padding: 10,
//         bodyFont: { size: 12 },
//       },
//     },
//     animation: {
//       animateRotate: true,
//       animateScale: true,
//       duration: 1000,
//     },
//     hover: {
//       mode: "nearest" as const,
//       intersect: true,
//     },
//     onHover: (event: any, chartElement: any) => {
//       event.native.target.style.cursor = chartElement[0]
//         ? "pointer"
//         : "default";
//     },
//   };

//   const today = moment(new Date()).format("YYYY-MM-DD");
//   const next15Days = moment(
//     new Date(new Date().setDate(new Date().getDate() + 15))
//   ).format("YYYY-MM-DD");

//   const handleEditLeadOrInquiry = async (data: any) => {
//     if (data?.FollowupType === "LEAD" && isLeadEditAccess) {
//       const drawerOptions: IDrawerState = {
//         open: true,
//         anchor: "right",
//         name: "leadForm",
//         drawerWidth: 400,
//         data: data?.LeadID ? +data?.LeadID : null,
//       };
//       dispatch(opened(drawerOptions));
//     } else if (data?.FollowupType === "INQUIRY" && isInquiryEditAccess) {
//       navigate("inquiry/edit", {
//         state: {
//           InquiryID: data?.InquiryID ? +data?.InquiryID : null,
//           RequirementType: data?.RequirementType,
//         },
//       });
//     }
//   };

//   const handleOpenCompleteFollowupDialog = (ID: number) => {
//     dispatch(openDialog("completeFollowup"));
//     dispatch(setFolloupID(ID));
//   };

//   const handleRedirect = (active: string) => {
//     dispatch(setActiveTabIndex(active === "Lead" ? 0 : 1));
//     navigate("dashboard/follow-ups", {
//       state: {
//         activeTab: active === "Lead" ? 0 : 1,
//         FromDate: dateFilter?.FromDate,
//         ToDate: dateFilter?.ToDate,
//       },
//     });
//   };

//   return (
//     <>
//       <FollowupCompleteDialog />
//       {loading ? (
//         <LoadingPanel gridRef={gridRef} />
//       ) : (
//         <div className="dashboard-container">
//           <motion.div
//             className="hero-banner"
//             initial={{ opacity: 0, y: -50 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//           >
//             <h1>Welcome back, {loginDetails?.FullName}!</h1>
//             <p>Explore AI Travel CRM Dashboard</p>
//           </motion.div>
//           <motion.div
//             className="dates-card"
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ delay: 0.1, duration: 0.5 }}
//           >
//             <Form
//               onSubmit={() => {}}
//               initialValues={formatedDateFilter}
//               render={(formRenderProps: FormRenderProps) => (
//                 <FormElement style={{ width: "100%" }}>
//                   <GridLayout
//                     style={{ marginRight: 40 }}
//                     gap={{ rows: 20, cols: 20 }}
//                     cols={[
//                       { width: "33.33%" },
//                       { width: "33.33%" },
//                       { width: "33.33%" },
//                     ]}
//                   >
//                     <GridLayoutItem>
//                       <Typography.h4 style={{ margin: 0 }}>
//                         My Dashboard
//                       </Typography.h4>
//                     </GridLayoutItem>
//                     <GridLayoutItem></GridLayoutItem>
//                     <GridLayoutItem className="d-flex justify-content-end align-items-center ">
//                       {formRenderProps.valueGetter("SelectedDate") ? (
//                         ""
//                       ) : (
//                         <span style={{ whiteSpace: "nowrap" }}>
//                           Next 15 Days Data!
//                         </span>
//                       )}
//                       {formRenderProps.valueGetter("SelectedDate") === 6 && (
//                         <>
//                           <Field
//                             wrapperStyle={{
//                               margin: "0 0 0 10px",
//                               width: 150,
//                               flex: "none",
//                             }}
//                             name="FromDate"
//                             component={FormDatePicker}
//                             format={"dd/MM/yyyy"}
//                             placeholder="From Date"
//                           />
//                           <Field
//                             wrapperStyle={{
//                               margin: "0 0 0 10px",
//                               width: 150,
//                               flex: "none",
//                             }}
//                             name="ToDate"
//                             component={FormDatePicker}
//                             format={"dd/MM/yyyy"}
//                             minDate={moment(
//                               formRenderProps.valueGetter("FromDate")
//                             ).toDate()}
//                             disabled={
//                               formRenderProps.valueGetter("FromDate")
//                                 ? false
//                                 : true
//                             }
//                             placeholder="To Date"
//                           />
//                         </>
//                       )}
//                       <Field
//                         wrapperStyle={{
//                           margin: "0 0 0 10px",
//                           width: 200,
//                           flex: "none",
//                         }}
//                         name="SelectedDate"
//                         component={FormSelectionField}
//                         size={"small"}
//                         placeholder="Filter"
//                         options={DateRangeFilter?.map((date: any) => {
//                           return {
//                             value: date.value,
//                             label: date.label,
//                           };
//                         })}
//                       />
//                     </GridLayoutItem>
//                   </GridLayout>
//                   <DateFilterChangeWatcher formRenderProps={formRenderProps} />
//                 </FormElement>
//               )}
//             />
//           </motion.div>
//           <div className="stats-grid">
//             {DashBoardCountList.map((card, index) => (
//               <Link
//                 to={
//                   !card.TotalCount
//                     ? "#"
//                     : (getDashboardCardData(card.Title, "link") as string)
//                 }
//                 state={{
//                   filter: {
//                     FromDate: dateFilter?.FromDate || today,
//                     ToDate: dateFilter?.ToDate || next15Days,
//                   },
//                 }}
//                 style={{
//                   textDecoration: "none",
//                   height: "100%",
//                   display: "block",
//                 }}
//               >
//                 <motion.div
//                   key={card.Title}
//                   className="stat-card"
//                   initial={{ opacity: 0, scale: 0.9 }}
//                   animate={{ opacity: 1, scale: 1 }}
//                   transition={{ delay: index * 0.2, duration: 0.5 }}
//                 >
//                   <span className="stat-icon">
//                     {getDashboardCardData(card.Title, "icon")}
//                   </span>
//                   <div className="state-card-text">
//                     <h3>{card.Title}</h3>
//                     <p>{card.TotalCount}</p>
//                   </div>
//                 </motion.div>
//               </Link>
//             ))}
//           </div>
//           <div className="main-content">
//             <motion.div
//               className="followups-card position-relative"
//               initial={{ opacity: 0, x: -50 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6 }}
//             >
//               {followUpLoading ? (
//                 <LoadingPanel gridRef={gridFOrmLoadingRef} />
//               ) : (
//                 <>
//                   <h2>Follow-ups</h2>
//                   <div className="followups-tabs">
//                     <motion.button
//                       className={`tab-btn ${
//                         activeTab === "Lead" ? "active" : ""
//                       }`}
//                       onClick={() => setActiveTab("Lead")}
//                       whileHover={{
//                         scale: 1.05,
//                         transition: { duration: 0.2 },
//                       }}
//                       whileTap={{ scale: 0.95 }}
//                     >
//                       Leads
//                     </motion.button>
//                     <motion.button
//                       className={`tab-btn ${
//                         activeTab === "Inquiry" ? "active" : ""
//                       }`}
//                       onClick={() => setActiveTab("Inquiry")}
//                       whileHover={{
//                         scale: 1.05,
//                         transition: { duration: 0.2 },
//                       }}
//                       whileTap={{ scale: 0.95 }}
//                     >
//                       Inquiries
//                     </motion.button>
//                   </div>
//                   <motion.ul
//                     className="followups-list"
//                     variants={listVariants}
//                     initial="hidden"
//                     animate="visible"
//                     key={activeTab}
//                   >
//                     {displayedFollowUps?.length > 0 ? (
//                       displayedFollowUps.slice(0, 3).map((followUp) => (
//                         <motion.li
//                           key={followUp.ID}
//                           className="followup-item"
//                           variants={itemVariants}
//                           style={{ padding: "4px" }}
//                           onClick={() => handleEditLeadOrInquiry(followUp)}
//                         >
//                           <div className="followup-header">
//                             <span className="lead-name">{followUp.Name}</span>
//                             <span className="followup-date-time">
//                               {followUp.FollowupDate} | {followUp.FollowupTime}
//                             </span>
//                           </div>
//                           <div className="followup-header gap-2">
//                             <p className="followup-description">
//                               {followUp.Remarks}
//                             </p>
//                             <span className="followup-date-time">
//                               <motion.button
//                                 className={`tab-btn active`}
//                                 onClick={(e: any) => {
//                                   e.stopPropagation();
//                                   handleOpenCompleteFollowupDialog(
//                                     followUp?.ID || 0
//                                   );
//                                 }}
//                                 whileHover={{
//                                   scale: 1.05,
//                                   transition: { duration: 0.2 },
//                                 }}
//                                 whileTap={{ scale: 0.95 }}
//                                 style={{ padding: "5px 10px" }}
//                               >
//                                 Complete
//                               </motion.button>
//                             </span>
//                           </div>
//                         </motion.li>
//                       ))
//                     ) : (
//                       <motion.p key="no-followups" className="no-followups">
//                         No follow-ups found for selected date range.
//                       </motion.p>
//                     )}
//                   </motion.ul>
//                   {displayedFollowUps?.length > 3 && (
//                     <motion.button
//                       className="see-more-btn"
//                       whileHover={{ scale: 1.05, backgroundColor: "#14386f" }} // Updated hover effect
//                       whileTap={{ scale: 0.95 }}
//                       transition={{ duration: 0.2 }}
//                       type="button"
//                       onClick={() => handleRedirect(activeTab)}
//                     >
//                       See More
//                     </motion.button>
//                   )}
//                 </>
//               )}
//             </motion.div>
//             <motion.div
//               className="pie-chart-card"
//               initial={{ opacity: 0, x: 50 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6 }}
//             >
//               <h2>Overview</h2>
//               <div className="chart-container">
//                 <Pie data={pieData} options={pieOptions} />
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// const FollowupCompleteDialog: React.FC = () => {
//   const dispatch = useAppDispatch();
//   const gridRef = useRef<any>(null);
//   const dialogName = useAppSelector((state) => state.dialog.dialogName);

//   const followUpLoading = useAppSelector(
//     (state) => state.dashboard.followUpLoading
//   );
//   const followupId = useAppSelector((state) => state.dashboard.followupId);
//   const dateFilter = useAppSelector((state) => state?.dashboard?.dateFilter);

//   const handleSubmit = async (values: any) => {
//     const payload = {
//       ID: followupId ? +followupId : null,
//       CompletedRemarks: values?.CompletedRemarks
//         ? values?.CompletedRemarks
//         : "",

//       IsCompleted: true,
//     };
//     if (followupId) {
//       const res = await dispatch(updateFollowUpStatus(payload));
//       if (res.meta.requestStatus === "fulfilled") {
//         const filter = {
//           FromDate: dateFilter.FromDate || "",
//           ToDate: dateFilter.ToDate || "",
//         };
//         dispatch(getDashBoardFollowups(filter));
//         dispatch(closeDialog());
//       }
//     }
//   };

//   return (
//     <>
//       {dialogName === "completeFollowup" && (
//         <AppDialog>
//           <>
//             {followUpLoading && <LoadingPanel gridRef={gridRef} />}
//             <Form
//               onSubmit={handleSubmit}
//               render={(formRenderProps: FormRenderProps) => (
//                 <FormElement style={{ minWidth: 500 }}>
//                   <GridLayout>
//                     <GridLayoutItem className="position-relative">
//                       <Typography.h4 className="typography-head">
//                         {"Complete Followup"}
//                       </Typography.h4>
//                       <IconButton
//                         className="typography-dialog-close-icon"
//                         type="button"
//                         fillMode={"flat"}
//                         themeColor={"dark"}
//                         style={{ marginRight: 4, top: 7 }}
//                         onClick={() => dispatch(closeDialog())}
//                         icon={RxCross1}
//                       />
//                     </GridLayoutItem>
//                     <GridLayoutItem>
//                       <Field
//                         id={"CompletedRemarks"}
//                         name={"CompletedRemarks"}
//                         label={"Completed Remarks"}
//                         placeholder={"Completed Remarks"}
//                         component={FormTextArea}
//                       />
//                     </GridLayoutItem>
//                     <GridLayoutItem
//                       style={{
//                         display: "flex",
//                         justifyContent: "end",
//                         marginTop: 20,
//                       }}
//                     >
//                       <DialogCloseButton themeColor="primary" />
//                       <ButtonWithLoading
//                         label={"Complete"}
//                         type="submit"
//                         disabled={
//                           !formRenderProps.allowSubmit || followUpLoading
//                         }
//                         loading={followUpLoading}
//                       />
//                     </GridLayoutItem>
//                   </GridLayout>
//                 </FormElement>
//               )}
//             />
//           </>
//         </AppDialog>
//       )}
//     </>
//   );
// };

// export default Dashboard;

import React, { useEffect, useRef } from "react";
import "./Dashboard.scss";
import IconComponent from "../../components/common/IconComponent";
import { TbReceiptRupee } from "react-icons/tb";
import { RiBookMarkedFill, RiInfoCardLine } from "react-icons/ri";
import { IoMdPersonAdd } from "react-icons/io";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { checkAcessRights, getFilterFromToDate } from "../../_helper/helper";
import moment from "moment";
import {
  getDashBoardCount,
  getDashBoardFollowups,
} from "./services/dashboard.services";
import {
  setActiveTabIndex,
  setDateFilter,
  setFolloupID,
} from "./dashboardSlice";
import { DateRangeFilter, EDIT_ACCESS } from "../../_contstants/common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { useNavigate } from "react-router-dom";
import { IDrawerState } from "../../components/drawer/drawerModel";
import { opened } from "../../components/drawer/drawerSlice";
import { updateFollowUpStatus } from "../inquiry/services/inquiry.services";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import { RxCross1 } from "react-icons/rx";
import FormTextArea from "../../components/formFields/FormTextArea";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { getAllActiveSectors } from "../sector/services/sector.services";
import { ISector } from "../sector/sectorModel";
ChartJS.register(ArcElement, Tooltip, Legend);

const DashBoardCardData = [
  // {
  //   title: "Bookings",
  //   icon: <IconComponent icon={BsBookmarkPlusFill} />,
  //   link: "dashboard/booking",
  // },
  {
    title: "Quotations",
    icon: <IconComponent icon={TbReceiptRupee} />,
    link: "dashboard/quotation",
    color: "blue",
  },
  {
    title: "Inquiries",
    icon: <IconComponent icon={RiInfoCardLine} />,
    link: "dashboard/inquiry",
    color: "green",
  },
  {
    title: "Leads",
    icon: <IconComponent icon={IoMdPersonAdd} />,
    link: "dashboard/lead",
    color: "purple",
  },
  {
    title: "FIT Bookings",
    icon: <IconComponent icon={RiBookMarkedFill} />,
    link: "dashboard/fitbooking",
    color: "orange",
  },
  {
    title: "Hotel Inquiries",
    icon: <IconComponent icon={RiBookMarkedFill} />,
    link: "dashboard/inquiry/Hotel Inquiry",
    color: "emerald",
  },
  {
    title: "Flight Inquiries",
    icon: <IconComponent icon={RiBookMarkedFill} />,
    link: "dashboard/inquiry/Flight Inquiry",
    color: "red",
  },
  {
    title: "Visa Inquiries",
    icon: <IconComponent icon={RiBookMarkedFill} />,
    link: "dashboard/inquiry/Visa Inquiry",
    color: "indigo",
  },
  {
    title: "Package Inquiries",
    icon: <IconComponent icon={RiBookMarkedFill} />,
    link: "dashboard/inquiry/Package Inquiry",
    color: "teal",
  },
];
const DBLeadStatusData = [
  {
    title: "Hot Inquiries",
    icon: <IconComponent icon={TbReceiptRupee} />,
    link: "dashboard/inquiry/Hot",
    bg_color: "bg-red-50",
    indicator_bg_color: "bg-warning",
    color: "text-warning",
  },
  {
    title: "Warm Inquiries",
    icon: <IconComponent icon={TbReceiptRupee} />,
    link: "dashboard/inquiry/Warm",
    bg_color: "bg-yellow-50",
    indicator_bg_color: "bg-danger",
    color: "text-danger",
  },
  {
    title: "Cold Inquiries",
    icon: <IconComponent icon={TbReceiptRupee} />,
    link: "dashboard/inquiry/Cold",
    bg_color: "bg-blue-50",
    indicator_bg_color: "bg-primary",
    color: "text-primary",
  },
];
const DBChartData = [
  {
    title: "Today Followup Inquiry",
    icon: <IconComponent icon={TbReceiptRupee} />,
    link: "dashboard/inquiry/Hot",
    bg_color: "bg-red-50",
    indicator_bg_color: "bg-danger",
    color: "text-danger",
  },
  {
    title: "Today Followup Lead",
    icon: <IconComponent icon={TbReceiptRupee} />,
    link: "dashboard/inquiry/Warm",
    bg_color: "bg-yellow-50",
    indicator_bg_color: "bg-warning",
    color: "text-warning",
  },
  {
    title: "Upcoming Task & Reminder Inquiry",
    icon: <IconComponent icon={TbReceiptRupee} />,
    link: "dashboard/inquiry/Cold",
    bg_color: "bg-blue-50",
    indicator_bg_color: "bg-primary",
    color: "text-primary",
  },
  {
    title: "Upcoming Task & Reminder Lead",
    icon: <IconComponent icon={TbReceiptRupee} />,
    link: "dashboard/inquiry/Cold",
    bg_color: "bg-blue-50",
    indicator_bg_color: "bg-primary",
    color: "text-primary",
  },
];

const getDashboardCardData = (
  data: any[],
  title: string,
  // type: "icon" | "link"
): any | undefined => {
  const item = data?.find((data) => data?.title === title);
  if (!item) return null;
  return item;
  // return type === "icon" ? item?.icon : item?.link || "#";
};

interface DateFilterChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const DateFilterChangeWatcher: React.FC<DateFilterChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const SelectedDate = formRenderProps.valueGetter("SelectedDate");
  const SectorID = formRenderProps.valueGetter("SectorID");
  const FromDate = formRenderProps.valueGetter("FromDate");
  const ToDate = formRenderProps.valueGetter("ToDate");
  const next15Days = new Date(new Date().setDate(new Date().getDate() + 15));

  useEffect(() => {
    if (SelectedDate !== 6) {
      formRenderProps.onChange("FromDate", { value: null });
      formRenderProps.onChange("ToDate", { value: null });
      const filter = getFilterFromToDate(SelectedDate);
      if (filter.FromDate === "" && filter.ToDate === "") {
        const DefaultDate = {
          FromDate: moment(new Date()).format("YYYY-MM-DD"),
          ToDate: moment(next15Days).format("YYYY-MM-DD"),
          SectorID,
        };
        dispatch(getDashBoardCount(DefaultDate));
        dispatch(getDashBoardFollowups(DefaultDate));
        dispatch(setDateFilter({ SelectedDate, ...DefaultDate }));
      } else {
        dispatch(getDashBoardCount({ SectorID, ...filter }));
        dispatch(getDashBoardFollowups({ SectorID, ...filter }));
        dispatch(setDateFilter({ SelectedDate, SectorID, ...filter }));
      }
    }
  }, [SelectedDate, SectorID]);

  useEffect(() => {
    const filter = {
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD")
        : moment(new Date()).format("YYYY-MM-DD"),
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : moment(next15Days).format("YYYY-MM-DD"),
      SectorID,
    };
    if (FromDate && ToDate) {
      dispatch(getDashBoardCount(filter));
      dispatch(getDashBoardFollowups(filter));
      dispatch(setDateFilter({ SelectedDate, ...filter }));
    }
  }, [FromDate, ToDate, SectorID]);
  return null;
};

const Dashboard: React.FC = () => {
  const gridRef = useRef<any>(null);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridFOrmLoadingRef = useRef<any>(null);
  const DashBoardCountList = useAppSelector(
    (state) => state.dashboard.DashBoardCountList,
  );
  const DashboardInquiryFollowups = useAppSelector(
    (state) => state.dashboard.DashboardInquiryFollowups,
  );
  const DashboardLeadFollowups = useAppSelector(
    (state) => state.dashboard.DashboardLeadFollowups,
  );
  const isLeadEditAccess = checkAcessRights("/lead", EDIT_ACCESS);
  const isInquiryEditAccess = checkAcessRights("/inquiry", EDIT_ACCESS);
  const SectorList = useAppSelector((state) => state.sector.SectorList);
  const dateFilter = useAppSelector((state) => state?.dashboard?.dateFilter);
  const formatedDateFilter = {
    ...dateFilter,
    FromDate: dateFilter.FromDate
      ? moment(dateFilter?.FromDate, "YYYY-MM-DD").toDate()
      : "",
    ToDate: dateFilter.ToDate
      ? moment(dateFilter?.ToDate, "YYYY-MM-DD").toDate()
      : "",
  };

  const loading = useAppSelector((state) => state.dashboard.loading);
  const followUpLoading = useAppSelector(
    (state) => state.dashboard.followUpLoading,
  );

  useEffect(() => {
    dispatch(getAllActiveSectors());
  }, []);

  const activities = [
    {
      icon: (
        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
          <path d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6z" />
        </svg>
      ),
      iconColor: "blue",
      title: "New inquiry from John Smith",
      time: "Flight booking to Dubai - 2 minutes ago",
    },
    {
      icon: (
        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
          />
        </svg>
      ),
      iconColor: "green",
      title: "Booking confirmed for Maria Garcia",
      time: "Hotel reservation in Paris - 15 minutes ago",
    },
    {
      icon: (
        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
          />
        </svg>
      ),
      iconColor: "yellow",
      title: "Follow-up reminder",
      time: "Call Robert Johnson about visa application - 1 hour ago",
    },
    {
      icon: (
        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
        </svg>
      ),
      iconColor: "purple",
      title: "Quote sent to client",
      time: "Europe tour package for Thompson family - 2 hours ago",
    },
  ];

  const doughnutData = {
    labels: DashBoardCountList?.filter((count: any) =>
      DBChartData?.some((db: any) => db.title === count?.Title),
    )?.map((e) => e?.Title),
    datasets: [
      {
        data: DashBoardCountList?.filter((count: any) =>
          DBChartData?.some((db: any) => db.title === count?.Title),
        ).map((card) => card.TotalCount),
        backgroundColor: ["#174583", "#4EBECF", "#17458380", "#4EBECF80"],
        borderColor: ["#174583", "#4EBECF", "#174583", "#4EBECF"],
        borderWidth: 2,
        hoverOffset: 5,
      },
    ],
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1,
    plugins: {
      legend: {
        position: "bottom" as const,
        labels: {
          color: "#333",
          font: { size: 14, weight: "bold" as const },
          padding: 20,
          boxWidth: 20,
          boxHeight: 20,
        },
      },
      tooltip: {
        backgroundColor: "#174583",
        titleColor: "white",
        bodyColor: "white",
        borderColor: "#4EBECF",
        borderWidth: 1,
        caretSize: 0,
        padding: 10,
        bodyFont: { size: 12 },
      },
    },
    animation: {
      animateRotate: true,
      animateScale: true,
      duration: 1000,
    },
    hover: {
      mode: "nearest" as const,
      intersect: true,
    },
    onHover: (event: any, chartElement: any) => {
      event.native.target.style.cursor = chartElement[0]
        ? "pointer"
        : "default";
    },
    onClick: (event: any, chartElement: any, chart: any) => {
      if (chartElement.length > 0) {
        const index = chartElement[0].index;
        const label = chart.data.labels[index];
        // if (label === "Some Title") {
        //   navigate("/path-one");
        // } else if (label === "Another Title") {
        //   navigate("/path-two");
        // } else {
        navigate(`/dashboard/followups/${label}`, {
          state: {
            FromDate: dateFilter?.FromDate,
            ToDate: dateFilter?.ToDate,
            SectorID: dateFilter?.SectorID || null,
            Type: label,
          },
        }); // fallback
        // }
      }
    },
  };

  const today = moment(new Date()).format("YYYY-MM-DD");
  const next15Days = moment(
    new Date(new Date().setDate(new Date().getDate() + 15)),
  ).format("YYYY-MM-DD");

  const handleAddInquiry = () => {
    console.log("Add inquiry clicked");
  };

  const handleCreateBooking = () => {
    console.log("Create booking clicked");
  };

  const handleGenerateQuote = () => {
    console.log("Generate quote clicked");
  };

  const handleViewReports = () => {
    console.log("View reports clicked");
  };

  const handleEditLeadOrInquiry = async (data: any) => {
    if (data?.FollowupType === "LEAD" && isLeadEditAccess) {
      const drawerOptions: IDrawerState = {
        open: true,
        anchor: "right",
        name: "leadForm",
        drawerWidth: 400,
        data: data?.LeadID ? +data?.LeadID : null,
      };
      dispatch(opened(drawerOptions));
    } else if (data?.FollowupType === "INQUIRY" && isInquiryEditAccess) {
      navigate("inquiry/edit", {
        state: {
          InquiryID: data?.InquiryID ? +data?.InquiryID : null,
          RequirementType: data?.RequirementType,
        },
      });
    }
  };

  const handleOpenCompleteFollowupDialog = (ID: number) => {
    dispatch(openDialog("completeFollowup"));
    dispatch(setFolloupID(ID));
  };

  const handleRedirect = (active: string) => {
    dispatch(setActiveTabIndex(active === "Lead" ? 0 : 1));
    navigate("dashboard/follow-ups", {
      state: {
        activeTab: active === "Lead" ? 0 : 1,
        FromDate: dateFilter?.FromDate,
        ToDate: dateFilter?.ToDate,
        SectorID: dateFilter?.SectorID || null,
      },
    });
  };

  return (
    <>
      <FollowupCompleteDialog />
      {loading ? (
        <LoadingPanel gridRef={gridRef} />
      ) : (
        <div className="dashboard-container">
          <div className="dashboard-content">
            <div className="dates-card">
              <Form
                onSubmit={() => {}}
                initialValues={formatedDateFilter}
                render={(formRenderProps: FormRenderProps) => (
                  <FormElement style={{ width: "100%" }}>
                    <GridLayout
                      style={{ marginRight: 40 }}
                      gap={{ rows: 20, cols: 20 }}
                      cols={[
                        { width: "25%" },
                        { width: "25%" },
                        { width: "25%" },
                        { width: "25%" },
                      ]}
                    >
                      <GridLayoutItem colSpan={3}>
                        <Typography.h4 style={{ margin: 0 }}>
                          My Dashboard
                        </Typography.h4>
                      </GridLayoutItem>
                      <GridLayoutItem className="d-flex justify-content-end align-items-center ">
                        {+formRenderProps.valueGetter("SelectedDate") ? (
                          ""
                        ) : (
                          <span style={{ whiteSpace: "nowrap" }}>
                            Next 15 Days Data!
                          </span>
                        )}
                        {+formRenderProps.valueGetter("SelectedDate") === 6 && (
                          <>
                            <Field
                              wrapperStyle={{
                                margin: "0 0 0 10px",
                                width: 150,
                                flex: "none",
                              }}
                              name="FromDate"
                              component={FormDatePicker}
                              format={"dd/MM/yyyy"}
                              placeholder="From Date"
                            />
                            <Field
                              wrapperStyle={{
                                margin: "0 0 0 10px",
                                width: 150,
                                flex: "none",
                              }}
                              name="ToDate"
                              component={FormDatePicker}
                              format={"dd/MM/yyyy"}
                              minDate={moment(
                                formRenderProps.valueGetter("FromDate"),
                              ).toDate()}
                              disabled={
                                !formRenderProps.valueGetter("FromDate")
                                  ? true
                                  : false
                              }
                              placeholder="To Date"
                            />
                          </>
                        )}
                        <Field
                          wrapperStyle={{
                            margin: "0 0 0 10px",
                            width: 200,
                            flex: "none",
                          }}
                          name="SelectedDate"
                          component={FormSelectionField}
                          size={"small"}
                          placeholder="Filter"
                          options={DateRangeFilter?.map((date: any) => {
                            return {
                              value: date.value,
                              label: date.label,
                            };
                          })}
                        />
                        <Field
                          wrapperStyle={{
                            margin: "0 20px 0 10px",
                            width: 200,
                            flex: "none",
                          }}
                          size={"small"}
                          name={"SectorID"}
                          placeholder="Filter By Sector"
                          component={FormSelectionField}
                          options={SectorList?.map((sector: ISector) => {
                            return {
                              value: sector?.ID,
                              label: sector?.SectorName,
                            };
                          })}
                        />
                      </GridLayoutItem>
                    </GridLayout>
                    <DateFilterChangeWatcher
                      formRenderProps={formRenderProps}
                    />
                  </FormElement>
                )}
              />
            </div>

            <div className="metrics-grid">
              {DashBoardCountList?.filter((count: any) =>
                DashBoardCardData?.some((db: any) => db.title === count?.Title),
              )?.map((metric, index) => (
                <div key={index} className="metric-card">
                  <div
                    className="metric-content"
                    onClick={() => {
                      navigate(
                        !metric.TotalCount
                          ? "#"
                          : getDashboardCardData(
                              DashBoardCardData,
                              metric.Title,
                            )?.link || "",
                        {
                          state: {
                            filter: {
                              FromDate: dateFilter?.FromDate || today,
                              ToDate: dateFilter?.ToDate || next15Days,
                              SectorID: dateFilter?.SectorID || null,
                            },
                            Type: metric?.Type,
                          },
                        },
                      );
                    }}
                  >
                    <div className="metric-text">
                      <div className="label">{metric.Title}</div>
                      <div className="value">{metric.TotalCount}</div>
                    </div>
                    <div
                      className={`metric-icon ${
                        getDashboardCardData(DashBoardCardData, metric.Title)
                          ?.color || ""
                      }`}
                      style={{ minWidth: 50 }}
                    >
                      {getDashboardCardData(DashBoardCardData, metric.Title)
                        ?.icon || ""}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="charts-section">
              <div className="lead-status">
                <h3>Inquiry Status</h3>
                {DashBoardCountList?.filter((count: any) =>
                  DBLeadStatusData?.some(
                    (db: any) => db.title === count?.Title,
                  ),
                )?.map((item, index) => (
                  <div
                    key={index}
                    className={`status-item ${
                      getDashboardCardData(DBLeadStatusData, item.Title)
                        ?.bg_color || ""
                    }`}
                    onClick={() => {
                      navigate(
                        !item.TotalCount
                          ? "#"
                          : getDashboardCardData(DBLeadStatusData, item.Title)
                              ?.link || "",
                        {
                          state: {
                            filter: {
                              FromDate: dateFilter?.FromDate || today,
                              ToDate: dateFilter?.ToDate || next15Days,
                              SectorID: dateFilter?.SectorID || null,
                            },
                            Type: item?.Type,
                          },
                        },
                      );
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        className={`status-indicator ${DBLeadStatusData[index]?.indicator_bg_color}`}
                      ></div>
                      <span className="status-name">{item.Title}</span>
                    </div>
                    <span
                      className={`status-count ${DBLeadStatusData[index]?.color}`}
                    >
                      {item.TotalCount}
                    </span>
                  </div>
                ))}
              </div>

              <div className="chart-card">
                <h3>Lead & Inquiries Followup</h3>
                <div className="chart-placeholder">
                  <Doughnut data={doughnutData} options={doughnutOptions} />
                </div>
              </div>
            </div>

            {false && (
              <div className="activities-actions">
                <div className="activities-card">
                  <h3>Recent Activities</h3>
                  {activities.map((activity, index) => (
                    <div key={index} className="activity-item">
                      <div className={`activity-icon ${activity.iconColor}`}>
                        {activity.icon}
                      </div>
                      <div className="activity-content">
                        <div className="activity-title">{activity.title}</div>
                        <div className="activity-time">{activity.time}</div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="actions-card">
                  <h3>Quick Actions</h3>
                  <div className="actions-grid">
                    <button
                      className="action-button blue"
                      onClick={handleAddInquiry}
                    >
                      <div className="action-icon">+</div>
                      <div className="action-text">Add Inquiry</div>
                    </button>
                    <button
                      className="action-button green"
                      onClick={handleCreateBooking}
                    >
                      <div className="action-icon">✓</div>
                      <div className="action-text">New Booking</div>
                    </button>
                    <button
                      className="action-button purple"
                      onClick={handleGenerateQuote}
                    >
                      <div className="action-icon">$</div>
                      <div className="action-text">Generate Quote</div>
                    </button>
                    <button
                      className="action-button orange"
                      onClick={handleViewReports}
                    >
                      <div className="action-icon">📊</div>
                      <div className="action-text">View Reports</div>
                    </button>
                  </div>

                  <div className="performance-summary">
                    <h4>Today's Performance</h4>
                    <div className="performance-grid">
                      <div className="performance-item">
                        <div className="label">Calls Made</div>
                        <div className="value blue">23</div>
                      </div>
                      <div className="performance-item">
                        <div className="label">Emails Sent</div>
                        <div className="value green">15</div>
                      </div>
                      <div className="performance-item">
                        <div className="label">Quotes Sent</div>
                        <div className="value purple">8</div>
                      </div>
                      <div className="performance-item">
                        <div className="label">Revenue Today</div>
                        <div className="value orange">$12,450</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="tasks-card">
              {followUpLoading ? (
                <LoadingPanel gridRef={gridFOrmLoadingRef} />
              ) : (
                <>
                  <div className="pt-2 pb-2 d-flex justify-content-between">
                    <h3 className="mb-0">Upcoming Tasks & Reminders</h3>
                    <div>
                      {DashboardInquiryFollowups?.length > 3 && (
                        <button
                          className="complete-button"
                          type="button"
                          onClick={() => handleRedirect("Inquiry")}
                        >
                          See More Inquiries
                        </button>
                      )}
                      {DashboardLeadFollowups?.length > 3 && (
                        <button
                          className="complete-button"
                          type="button"
                          style={{ marginLeft: 10 }}
                          onClick={() => handleRedirect("Lead")}
                        >
                          See More Leads
                        </button>
                      )}
                    </div>
                  </div>
                  <table className="tasks-table">
                    <thead>
                      <tr>
                        <th>Client</th>
                        <th>Sector</th>
                        <th>Travel Date</th>
                        <th>Date & Time</th>
                        <th>Remarks</th>
                        <th>Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {DashboardInquiryFollowups?.slice(0, 3)?.map(
                        (task: any, index: number) => (
                          <tr
                            key={index}
                            onClick={() => handleEditLeadOrInquiry(task)}
                          >
                            <td>{task?.Name}</td>
                            <td>{task?.SectorName}</td>
                            <td>{task?.TravelDate}</td>
                            <td>
                              {task?.FollowupDate}{" "}
                              {task?.FollowupTime
                                ? moment(task?.FollowupTime, "HH:mm:ss").format(
                                    "HH:mm A",
                                  )
                                : ""}
                            </td>
                            <td>{task?.Remarks}</td>
                            <td>
                              <span className={`priority-badge high`}>
                                {task?.FollowupType}
                              </span>
                            </td>
                            <td>
                              <button
                                className={`complete-button`}
                                onClick={(e: any) => {
                                  e.stopPropagation();
                                  handleOpenCompleteFollowupDialog(
                                    task?.ID || 0,
                                  );
                                }}
                                style={{ padding: "5px 10px" }}
                              >
                                Complete
                              </button>
                            </td>
                          </tr>
                        ),
                      )}
                      {DashboardLeadFollowups?.slice(0, 3)?.map(
                        (task: any, index: number) => (
                          <tr
                            key={index}
                            onClick={() => handleEditLeadOrInquiry(task)}
                          >
                            <td>{task?.Name}</td>
                            <td>{task?.SectorName}</td>
                            <td>{task?.TravelDate}</td>
                            <td>
                              {task?.FollowupDate}{" "}
                              {task?.FollowupTime
                                ? moment(task?.FollowupTime, "HH:mm:ss").format(
                                    "HH:mm A",
                                  )
                                : ""}
                            </td>
                            <td>{task?.Remarks}</td>
                            <td>
                              <span className={`priority-badge low`}>
                                {task?.FollowupType}
                              </span>
                            </td>
                            <td>
                              <button
                                className={`complete-button`}
                                onClick={(e: any) => {
                                  e.stopPropagation();
                                  handleOpenCompleteFollowupDialog(
                                    task?.ID || 0,
                                  );
                                }}
                                style={{ padding: "5px 10px" }}
                              >
                                Complete
                              </button>
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const FollowupCompleteDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const followUpLoading = useAppSelector(
    (state) => state.dashboard.followUpLoading,
  );
  const followupId = useAppSelector((state) => state.dashboard.followupId);
  const dateFilter = useAppSelector((state) => state?.dashboard?.dateFilter);

  const handleSubmit = async (values: any) => {
    const payload = {
      ID: followupId ? +followupId : null,
      CompletedRemarks: values?.CompletedRemarks
        ? values?.CompletedRemarks
        : "",

      IsCompleted: true,
    };
    if (followupId) {
      const res = await dispatch(updateFollowUpStatus(payload));
      if (res.meta.requestStatus === "fulfilled") {
        const filter = {
          FromDate: dateFilter.FromDate || "",
          ToDate: dateFilter.ToDate || "",
          SectorID: dateFilter.SectorID || null,
        };
        dispatch(getDashBoardFollowups(filter));
        dispatch(closeDialog());
      }
    }
  };

  return (
    <>
      {dialogName === "completeFollowup" && (
        <AppDialog>
          <>
            {followUpLoading && <LoadingPanel gridRef={gridRef} />}
            <Form
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 500 }}>
                  <GridLayout>
                    <GridLayoutItem className="position-relative">
                      <Typography.h4 className="typography-head">
                        {"Complete Followup"}
                      </Typography.h4>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ marginRight: 4, top: 7 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        id={"CompletedRemarks"}
                        name={"CompletedRemarks"}
                        label={"Completed Remarks"}
                        placeholder={"Completed Remarks"}
                        component={FormTextArea}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: 20,
                      }}
                    >
                      <DialogCloseButton themeColor="primary" />
                      <ButtonWithLoading
                        label={"Complete"}
                        type="submit"
                        disabled={
                          !formRenderProps.allowSubmit || followUpLoading
                        }
                        loading={followUpLoading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Dashboard;
